

import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { Icons, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import { bottom } from "@popperjs/core";
import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import { subAdminValidator } from "../../utils/validators";
import {
  extractDate,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

// React Icons
import { BsPlus } from "react-icons/bs";
import { RiEdit2Line } from "react-icons/ri";
import { MdExpandMore } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  Button,
  Fields,
  CommonButton,
  ProfileDetailForm,
} from "./CMSElement";
import { colors } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    // minHeight: "87vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
  },
}));

const FAQs = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "CMS Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;


  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [allFaqData, setAllFaqData] = useState();

  const [serviceType, setServiceType] = useState(
    localStorage.getItem("serviceTypefaq") || "serviceProvider"
  ); // Default to "serviceProvider"

  const handleServiceTypeChange = (type) => {
    setServiceType(type);
    localStorage.setItem("serviceTypefaq", type); // Save the active tab to localStorage
  };

  const [FAQsId, setFAQsId] = useState();
  const [deleteModal, setDeleteModal] = useState(false);

  // Fetch FAQ Data
  const fetchFAQUs = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`/getAllFaq/${serviceType}`);

      setAllFaqData(data?.data);
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFAQUs();
  }, [serviceType]); // Re-fetch when serviceType changes

  // Delete FAQs
  const DeleteFAQs = async (id = null) => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/deleteFaq/${id}`);

      setDeleteModal(false);
      toast.success(data?.message);
      fetchFAQUs(); // Refresh table after deletion
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleErrorResponse = (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "";

    if (status === 422) {
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
    } else if (error?.response?.status === 901) {
      subadminAccessChange(navigate);
      toast.error(`${error.response.data?.message}`, {
        position: "top-right",
      });
    } else if (status === 419) {
      localStorage.clear();
      Cookies.remove("showProfileSidebar");
      setUsers("");
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
      navigate("/");
    } else {
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
    }
  };


  function stripHtml(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="common-heading">FAQs</div>
              {!(!canAdd && adminData?.userType === "subAdmin") && (
                <Button
                  style={{ border: "1px solid #5088FB", backgroundColor: " #5088FB" }}
                  onClick={() => {
                    navigate("/addUpdateFAQs");
                  }}
                // disabled={!canAdd && adminData?.userType === "subAdmin"}
                >
                  <BsPlus
                    style={{
                      color: "#ffffff",
                      marginRight: "6px",
                      fontSize: "1.5rem",
                    }}
                  />
                  Manage FAQ
                </Button>
              )}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                paddingTop: "1rem",
              }}
            >
              <Button
                style={{

                  backgroundColor:
                    serviceType === "serviceProvider" ? "#5088FB" : "#ffffff",
                  color:
                    serviceType === "serviceProvider" ? "#ffffff" : "#201D23",
                  padding: "0.5rem 1.5rem",
                  border: "1px solid #26344E38",
                }}
                onClick={() => handleServiceTypeChange("serviceProvider")}
              >
                {/* Service Provider */}
                Job Host
              </Button>
              <Button
                style={{
                  backgroundColor:
                    serviceType === "user" ? "#5088FB" : "#ffffff",
                  color: serviceType === "user" ? "#ffffff" : "#201D23",
                  padding: "0.5rem 1.5rem",
                  border: "1px solid #26344E38",
                }}
                onClick={() => handleServiceTypeChange("user")}
              >
                {/* End User */}
                Job Seeker
              </Button>
            </div>

            <DashboardHeading>
              {(allFaqData || []).map((faq, index) => (
                <Accordion
                  key={faq._id}
                  sx={{
                    marginBottom: "10px",
                    border: "1px solid #375DFB54",
                    borderRadius: "6px",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<MdExpandMore style={{ fontSize: "1.8rem" }} />}
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                  >
                    <Typography component="span" style={{ color: "#181818", fontFamily: "Roboto", fontWeight: "500" }}>
                      {index + 1}. {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                    {/* <Typography style={{fontSize: "15px"}}>{faq.answer}</Typography> */}
                    <Typography
                      style={{ fontSize: "15px" }}
                      component="div"
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                        style={{ whiteSpace: "pre-wrap" }}
                      />
                    </Typography>
                    <AccordionActions
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        gap: "1rem",
                      }}
                    >
                      {!(!canEdit && adminData?.userType === "subAdmin") && (
                        <CommonButton
                          onClick={() =>
                            navigate(`/addUpdateFAQs`, {
                              state: { faq },
                            })
                          }
                        // disabled={!canEdit && adminData?.userType === "subAdmin"}
                        >
                          <RiEdit2Line style={{ fontSize: "1.5rem" }} />
                        </CommonButton>
                      )}
                      {!(!canDelete && adminData?.userType === "subAdmin") && (
                        <CommonButton
                          style={{
                            backgroundColor: "#f56c8938",
                            color: "#fe1717",
                          }}
                          onClick={() => {
                            setFAQsId(faq._id);
                            setDeleteModal(true);
                          }}
                        // disabled={!canDelete && adminData?.userType === "subAdmin"}
                        >
                          <RiDeleteBinLine style={{ fontSize: "1.5rem" }} />
                        </CommonButton>
                      )}
                    </AccordionActions>
                  </AccordionDetails>
                </Accordion>
              ))}
            </DashboardHeading>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {/* Modal for Delete User  */}
      <Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  setDeleteModal(false);
                }}
              />
            </div>
            <p className="profile-section-text">Delete FAQs</p>
            <div className="logout-header" style={{ paddingTop: "0px" }}>
              Are you sure you want to delete FAQs? Deleting them will
              permanently remove all their data.
            </div>
          </div>
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setDeleteModal(false);
                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#5088FB" }}
                onClick={() => DeleteFAQs(FAQsId)}
              >
                Confirm
              </div>
            </div>
          </>
        }
      />

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQs);

